import { useEffect, useState } from "react";
import { api, formatDate, errMsg, confirmDelete } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DataTable } from "@/components/DataTable";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

/** Two-way excavation index: by=vehicle → each vehicle's works (date → customer); by=customer → works done for the customer (date → vehicle). */
export function ExcavationHistory({ by, reloadKey }) {
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  const [tick, setTick] = useState(0);
  const isVehicle = by === "vehicle";
  useEffect(() => { api.get("/excavation-history/summary", { params: { by } }).then((r) => setRows(r.data)); }, [by, reloadKey, tick]);
  return (
    <Card className="p-4">
      <DataTable testIdPrefix={`history-${by}`} rows={rows} onRowClick={setSel} empty="Kayıt yok" columns={[
        { key: "name", label: isVehicle ? "Araç (Plaka)" : "Müşteri", className: isVehicle ? "font-mono font-semibold" : "font-medium" },
        { key: "count", label: "İş / Sefer", align: "right", render: (r) => <b>{r.count}</b> },
        { key: "related_count", label: isVehicle ? "Müşteri Sayısı" : "Araç Sayısı", align: "right" },
        { key: "first_date", label: "İlk İş", render: (r) => formatDate(r.first_date) },
        { key: "last_date", label: "Son İş", render: (r) => formatDate(r.last_date) }]} />
      <HistoryDialog sel={sel} by={by} onClose={() => setSel(null)} onChange={() => setTick((t) => t + 1)} />
    </Card>
  );
}

function HistoryDialog({ sel, by, onClose, onChange }) {
  const [items, setItems] = useState([]);
  const isVehicle = by === "vehicle";
  const load = () => sel && api.get("/excavation-history", { params: isVehicle ? { vehicle_id: sel.id } : { customer_id: sel.id } }).then((r) => setItems(r.data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setItems([]); load(); }, [sel]);
  const del = async (t) => {
    try { if (await confirmDelete(`/excavation-trips/${t.id}`)) { toast.success("Kayıt silindi"); load(); onChange(); } } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!sel} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="history-dialog">
        <DialogHeader><DialogTitle>{sel?.name} — {isVehicle ? "yaptığı işler" : "yapılan işler"} ({items.length})</DialogTitle></DialogHeader>
        <DataTable testIdPrefix="history-item" rows={items} empty="Kayıt yok" columns={[
          { key: "trip_date", label: "Tarih", render: (t) => <b>{formatDate(t.trip_date)}</b> },
          isVehicle ? { key: "customer_name", label: "İşi Kime Yaptık?" } : { key: "plate", label: "Araç", className: "font-mono font-semibold" },
          { key: "job_name", label: "İş" },
          { key: "material_type", label: "Malzeme" },
          { key: "x", label: "", render: (t) => <Button size="sm" variant="ghost" className="text-rose-600" onClick={() => del(t)} data-testid={`delete-history-${t.id}`}><Trash2 className="w-4 h-4 mr-1" />Sil</Button> }]} />
      </DialogContent>
    </Dialog>
  );
}
